import React, { useEffect, useState } from 'react';
import Pagination from './Pagination';
import Table from './Table';

function Favourites() {

  let genreIDs = {
    28: 'Action', 12: 'Adventure', 16: 'Animation', 35: 'Comedy', 80: 'Crime', 99: 'Documentary', 18: 'Drama', 10751: 'Family', 14: 'Fantasy', 36: 'History',
    27: 'Horror', 10402: 'Music', 9648: 'Mystery', 10749: 'Romance', 878: 'Sci-Fi', 10770: 'TV', 53: 'Thriller', 10752: 'War', 37: 'Western'
  }

  const [selectedGenere, setSelectedGenere] = useState("All Genres");
  const [favourites, setFavourites] = useState([]);
  const [generes, setGeneres] = useState([]);
  const [rating, setRating] = useState(0);
  const [popularity, setPopularity] = useState(0);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(5); // number of rows per page
  const [currPage, setCurrPage] = useState(1);


  // for getting movies in table from LOCAL STORAGE 
  useEffect(()=>{
    let oldFav = localStorage.getItem("favourites");
    oldFav = JSON.parse(oldFav) || []; //if no favs in local storage, then empty array
    setFavourites([...oldFav]);
  },[])

  // for genres get -> to build those blue/gray buttons for genres selction according to their presence in favourites
  useEffect(()=>{
    console.log(favourites);
    let genreOfFavs = favourites.map((movie) => genreIDs[movie.genre_ids[0]]);
    genreOfFavs = new Set(genreOfFavs); // to remove duplicates
    console.log(genreOfFavs);
    setGeneres(["All Genres",...genreOfFavs]);
  },[favourites])

  // delete from fav in table in fav list
  let removeFavourite = (movie) => {
    let newFav = favourites.filter(fav => fav.id !== movie.id);
    setFavourites(newFav);
    localStorage.setItem('favourites', JSON.stringify(newFav));
  }

  // filter movies according to selected genre
  let filteredFavourites = []; // to store filtered movies according to selected genre

  if(selectedGenere === "All Genres"){
    filteredFavourites = favourites;
  } 
  else{
    filteredFavourites = favourites.filter(movie => genreIDs[movie.genre_ids[0]] === selectedGenere); 
  }

  //sorting 
  if(rating === 1){
    filteredFavourites = filteredFavourites.sort((objA,objB) => objB.vote_average - objA.vote_average);
  }
  else if(rating === -1){
    filteredFavourites = filteredFavourites.sort((objA,objB) => objA.vote_average - objB.vote_average);
  } 
  if(popularity === 1){
    filteredFavourites = filteredFavourites.sort((objA,objB) => objB.popularity - objA.popularity);
  }
  else if(popularity === -1){
    filteredFavourites = filteredFavourites.sort((objA,objB) => objA.popularity - objB.popularity);
  }

  // sorting according to rating and popularity
  // when sort by popularity, set rating to 0
  // when sort by rating, set popularity to 0

  function setRatingHighToLow(){
    setRating(1);
    setPopularity(0);
  }
  function setRatingLowToHigh(){
    setRating(-1); 
    setPopularity(0);
  }
  function setPopularityHighToLow(){
    setPopularity(1);
    setRating(0);
  }
  function setPopularityLowToHigh(){
    setPopularity(-1);
    setRating(0);
  }

  // searching
  filteredFavourites = filteredFavourites.filter(movie => movie.title.toLowerCase().includes(search.toLowerCase()));

  //pagination
  let maxPage = Math.ceil((filteredFavourites.length)/rows);
  let startIndex = (currPage-1)*rows;
  let endIndex = Number(startIndex) + Number(rows);

  filteredFavourites = filteredFavourites.slice(startIndex,endIndex);

  let gotoPrevPage = () => {
    if(currPage>1){
      setCurrPage((currPage)=>currPage-1);
    }
  }
  let gotoNextPage = () => {
    if(currPage<maxPage){
      setCurrPage((currPage)=>currPage+1);
    }
    }




  return(
    <>
      <div className='mt-4 flex justify-center flex-wrap space-x-2'>
        {generes.map((genre) => 
          <button className={
            selectedGenere== genre ?
            'bg-blue-500 text-white text-lg font-bold p-1 px-2 rounded-xl m-2':
            'bg-gray-500 hover:bg-blue-400 text-white text-lg font-bold p-1 px-2 rounded-xl m-2'} 
            onClick={()=>{
              setCurrPage(1);
              setSelectedGenere(genre);
            }}
            >
              {genre}
          </button>
        )}
      </div>
      <div className='text-center'>
        <input 
          type='text'
          value={search}
          onChange={(e) => setSearch(e.target.value)} 
          placeholder='Search' 
          className='border border-2 text-center p-1 m-2'
        />
        <input 
        type='number'
        value={rows}
        onChange={(e) => setRows(e.target.value)}
        placeholder='Rows' 
        className='border border-2 text-center p-1 m-2'/>
      </div>

      {/* Table container */}
      <div className='mt-4'>

        <Table 
          filteredFavourites={filteredFavourites} 
          removeFavourite={removeFavourite} 
          setRatingHighToLow={setRatingHighToLow} 
          setRatingLowToHigh={setRatingLowToHigh} 
          setPopularityLowToHigh={setPopularityLowToHigh} 
          setPopularityHighToLow={setPopularityHighToLow}
        />
        <Pagination pageNumber={currPage} gotoNextPage={gotoNextPage} gotoPrevPage={gotoPrevPage}/>
      </div>
    </>

  );
}

export default Favourites;
